import React, { useState, useEffect } from 'react';
import { Add, ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import {
  Drawer, IconButton,
  List, Link,
  Button,
  ListItem,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Typography,
  ListItemText,
  Tooltip,
  Collapse,
  Checkbox,
} from '@material-ui/core';
import {
  ExpandLess,
  ExpandMore,
} from '@material-ui/icons';
import { useTheme } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import useStyles from './styles';
import SidebarLink from './components/SidebarLink/SidebarLink';
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from '../../context/LayoutContext';
import { handleUndefined, postDataRequest } from '../../common/commonfunctions';
import config from '../../config';
import { WhiteLabelSettingByBusiness } from '../../Api Mutation/WhiteLabelSettingApi';
import { allowedBusinessIds, customOrder, leadFinderModule, linkedinModule, menusToRemove, modulesToRemove } from '../../common/const';
import { LoadingPage } from '../../pages/LoadingPage/LoadingPage';
import { showNotification } from '../Notification/ToastifyNotifications';
import { UpdateUserPinMenu, UserPinMenusByUser } from '../../Api Mutation/UserManagementAPI';

function Sidebar({
  location,
  structure,
  getToogleBodyStatus,
  userPermissions,
  home,
  settings,
  professionalServices,
  reputationCentral,
  prospectCentral,
  marketingCentral,
  promotionCentral,
  productService,
  insightsCentral,
  leadCentral,
  salesCentral,
  propertyManagement,
  linkedIn,
  whastApp,
  menuPermissions,
  menuData
}) {
  const classes = useStyles();
  const theme = useTheme();
  const [dataLoading, setDataLoading] = useState(false);
  const [whiteLabelData, setWhiteLabelData] = useState(null);
  const [filteredStructure, setFilteredStructure] = useState([]);
  const [openOnHover, setOpenOnHover] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [updatedMenuData, setUpdatedMenuData] = useState([]);
  // global
  const {
    isSidebarOpened,
  } = useLayoutState();
  const businessId = handleUndefined(JSON.parse(localStorage?.getItem('business_Id')));
  const layoutDispatch = useLayoutDispatch();
  // local
  const [isPermanent, setPermanent] = useState(true);
  const [pinnedItems, setPinnedItems] = useState([]);
  const [openItems, setOpenItems] = useState({});

  const togglePin = (menu) => {
    const items = [...pinnedItems];
    if (menu.modules?.length > 0) {
      const allModulesExist = menu.modules?.every((mod) =>
        items.some((item) => item.menuid === menu.menuid && item.moduleid === mod.moduleid)
      );

      if (allModulesExist) {
        // Remove only the modules in menu.modules for this menu
        for (let i = items.length - 1; i >= 0; i--) {
          if (
            items[i].menuid === menu.menuid &&
            menu.modules?.some((mod) => mod.moduleid === items[i].moduleid)
          ) {
            items.splice(i, 1);
          }
        }
      } else {
        // Add missing modules for this menu
        menu.modules?.forEach((mod) => {
          const exists = items.some(
            (item) => item.menuid === menu.menuid && item.moduleid === mod.moduleid
          );
          if (!exists) {
            items.push({
              menuid: menu.menuid,
              moduleid: mod.moduleid
            });
          }
        });
      }
    } else {
      const index = items.findIndex((a) => a.moduleid === menu.moduleid);
      if (index > -1) {
        items.splice(index, 1);
      } else {
        items.push({
          menuid: menu.menuid,
          moduleid: menu.moduleid
        });
      }
    }
    setPinnedItems(items);
  };

  const toggleOpen = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  function handleWindowWidthChange() {
    const windowWidth = window.innerWidth;
    const breakpointWidth = theme.breakpoints.values.md;
    const isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
  const toggleDrawer = (value) => (event) => {
    if (getToogleBodyStatus) { getToogleBodyStatus(false); }
    if (
      event.type === 'keydown'
      && (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    if (value && !isPermanent) toggleSidebar(layoutDispatch);
  };
  const [openSideBar, setOpenSideBar] = useState();

  const hasPermission = () => {
    const allPermissions = [
      ...(Array.isArray(menuPermissions.homePermissions) ? menuPermissions.homePermissions : []),
      ...(Array.isArray(menuPermissions.reputationPermissions) ? menuPermissions.reputationPermissions : []),
      ...(Array.isArray(menuPermissions.crmPermissions) ? menuPermissions.crmPermissions : []),
      ...(Array.isArray(menuPermissions.insightsPermissions) ? menuPermissions.insightsPermissions : []),
      ...(Array.isArray(menuPermissions.leadsPermissions) ? menuPermissions.leadsPermissions : []),
      ...(Array.isArray(menuPermissions.salesPermissions) ? menuPermissions.salesPermissions : []),
      ...(Array.isArray(menuPermissions.marketingPermissions) ? menuPermissions.marketingPermissions : []),
      ...(Array.isArray(menuPermissions.professionalPermissions) ? menuPermissions.professionalPermissions : []),
      ...(Array.isArray(menuPermissions.propertyManagementPermissions) ? menuPermissions.propertyManagementPermissions : []),
      ...(Array.isArray(menuPermissions.workflowPermissions) ? menuPermissions.workflowPermissions : []),
      ...(Array.isArray(menuPermissions.linkedInPermissions) ? menuPermissions.linkedInPermissions : []),
      ...(Array.isArray(menuPermissions.whatsAppPermissions) ? menuPermissions.whatsAppPermissions : []),
    ];

    // Return true if at least one ID matches
    return userPermissions?.some((id) => allPermissions?.includes(id));
  };

  const getWhiteLabeleData = () => {
    if (businessId) {
      postDataRequest(config?.baseURLApi, {
        query: WhiteLabelSettingByBusiness,
        variables: {
          businessid: businessId,
        },
      }).then((response) => {
        if (response?.errors && response?.errors[0]?.message) {
          showNotification(response.errors[0].message, 'error');
        } else if (response?.data?.whiteLabelSettingsByBusiness) {
          setWhiteLabelData(response?.data?.whiteLabelSettingsByBusiness);
        }
      });
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (businessId) {
        getWhiteLabeleData();
      }
    }
    return () => {
      isMounted = false;
    };
  }, [businessId]);

  const getMenus = async () => {
    setDataLoading(true);
    await postDataRequest(config.baseURLApi, {
      query: UserPinMenusByUser,
      variables: {
        userid: JSON.parse(localStorage.getItem('userid'))
      },
    }).then((res) => {
      if (res?.errors && res?.errors[0]?.message) {
        showNotification(res.errors[0].message, 'error');
      } else if (res?.data?.userPinMenusByUser) {
        setPinnedItems(res?.data?.userPinMenusByUser?.pinmenus || []);
      }
      setDataLoading(false);
    });
  }

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (JSON.parse(localStorage.getItem('userid'))) {
        getMenus();
      }
    }
    return () => {
      isMounted = false;
    };
  }, [JSON.parse(localStorage.getItem('userid')), menuOpen])

  useEffect(() => {
    const filteredArr = structure.filter((la) => {
      const permissionsMap = {
        'Home': menuPermissions?.homePermissions?.length > 0 ? menuPermissions?.homePermissions : [],
        'Leads': menuPermissions?.leadsPermissions?.length > 0 ? menuPermissions?.leadsPermissions : [],
        'CRM': menuPermissions?.crmPermissions?.length > 0 ? menuPermissions?.crmPermissions : [],
        'Marketing': menuPermissions?.marketingPermissions?.length > 0 ? menuPermissions?.marketingPermissions : [],
        'Sales': menuPermissions?.salesPermissions?.length > 0 ? menuPermissions?.salesPermissions : [],
        'Reputation': menuPermissions?.reputationPermissions?.length > 0 ? menuPermissions?.reputationPermissions : [],
        'Insights': menuPermissions?.insightsPermissions?.length > 0 ? menuPermissions?.insightsPermissions : [],
        'Professional Services': menuPermissions?.professionalPermissions?.length > 0 ? menuPermissions?.professionalPermissions : [],
        'Property Management': menuPermissions?.propertyManagementPermissions?.length > 0 ? menuPermissions?.propertyManagementPermissions : [],
        'Workflows': menuPermissions?.workflowPermissions?.length > 0 ? menuPermissions?.workflowPermissions : [],
        'LinkedIn': menuPermissions?.linkedInPermissions?.length > 0 ? menuPermissions?.linkedInPermissions : [],
        'WhatsApp': menuPermissions?.whatsAppPermissions?.length > 0 ? menuPermissions?.whatsAppPermissions : [],
      };

      // Get the permissions for the current menu item
      const requiredPermissions = permissionsMap[la?.label] || [];

      // Check if the user has any of the required permissions
      const hasPermission = userPermissions?.some((permissionId) =>
        requiredPermissions.includes(permissionId)
      );

      // Filter out the menu item if the user doesn't have the required permissions
      if (requiredPermissions.length > 0 && !hasPermission) {
        return false; // Filter out this menu item
      }
      return true; // Keep the menu item
    });
    let newArr = [...(filteredArr || [])];

    if (!allowedBusinessIds.includes(businessId)) {
      newArr = newArr.filter(f => f?.label !== "Property Management");
    }

    const allowedLinkedInBusinessIds = [
      '4d730664-23d5-4a8e-87da-2c7f26f0e3f5',
      '2835a3ba-d780-4feb-8a51-52b875bb8d39'
    ]

    if (businessId === 'e802f5f2-0cf3-4e24-88ea-a13b81ef1807') {
      newArr = newArr.filter(f => f?.label !== "WhatsApp" && f?.label !== "LinkedIn" && f?.sideModule !== 'Email Finder');
    }
    
    if (allowedLinkedInBusinessIds.includes(businessId)) {
      newArr = newArr.filter(f => f?.label !== "WhatsApp");
      newArr = newArr.map(f => {
        if (f?.label === "LinkedIn") {
          return {
            ...f,
            children: f.children?.filter(
              item =>
                !["Inbox", "Manage Invitations", "Advance LinkedIn Sequence"].includes(
                  item.sideModule
                )
            )
          };
        }
        return f;
      });
    } else {
      if (businessId !== "20811bc0-12c1-4d8e-9527-5f0cae397536") {
        newArr = newArr.map(f => {
          if (f?.label === "LinkedIn") {
            return {
              ...f,
              children: f.children?.filter(
                item =>
                  !["LinkedIn Sequence"].includes(
                    item.sideModule
                  )
              )
            };
          }
          return f;
        });
      }
    }

    const filteredArray = newArr.map(item => {
      // If item has children
      if (item.children && item.children.length > 0) {
        // Filter children: keep only those matching both moduleid and parent menuid
        const filteredChildren = item.children.filter(child => {
          return pinnedItems.some(perm =>
            perm.moduleid === child.moduleid &&
            perm.menuid === item.menuid
          );
        });

        // Include parent only if it has at least one valid child
        if (filteredChildren.length > 0) {
          return {
            ...item,
            children: filteredChildren
          };
        }
        return null;
      } else {
        // No children: check if moduleid matches directly
        const hasMatchingModuleId = pinnedItems.some(perm =>
          perm.moduleid === item.moduleid
        );

        return hasMatchingModuleId ? item : null;
      }
    }).filter(item => item !== null)
      .filter(item => !item.children || item.children.length > 0);

    setFilteredStructure(filteredArray);
  }, [structure, userPermissions, menuPermissions, businessId, pinnedItems]);

  useEffect(() => {
    window.addEventListener('resize', handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener('resize', handleWindowWidthChange);
    };
  });

  useEffect(() => {
    if (menuOpen) {
      const modulesToPromote = ["Appointments", "Contacts", "Email Finder", "Workflows"];
      const flattenedModules = [];

      const updatedMenu = menuData
        .filter(menu => {
          if (menusToRemove.includes(menu.name)) return false;
          if (menu.name === "Property Management" && !allowedBusinessIds.includes(businessId)) return false;
          return true;
        })
        .map(menu => {
          const remainingModules = [];

          menu.modules.forEach(module => {
            if (modulesToPromote.includes(module.name)) {
              flattenedModules.push({
                menuid: menu.menuid,
                menu: menu.name,
                moduleid: module.moduleid,
                modulename: module.name
              });
            } else if (!modulesToRemove.includes(module.name)) {
              remainingModules.push({
                name: module.name,
                moduleid: module.moduleid
              });
            }
          });
          if (menu.menuid === linkedinModule) {
            remainingModules.push(
              { name: 'Manage Invitations', moduleid: 57, menuid: menu.menuid },
              { name: 'Messaging', moduleid: 58, menuid: menu.menuid },
              { name: 'Connect LinkedIn', moduleid: 70, menuid: menu.menuid },
              { name: 'LinkedIn Finder', moduleid: 71, menuid: menu.menuid }
            )
          }
          return {
            name: menu.name,
            menuid: menu.menuid,
            modules: remainingModules
          };
        });

      const combined = [...updatedMenu, ...flattenedModules];

      function getSortKey(item) {
        let key = item.modulename || item.name || "";
        return key;
      }

      const finalMenu = combined.sort((a, b) => {
        const aIndex = customOrder.indexOf(getSortKey(a));
        const bIndex = customOrder.indexOf(getSortKey(b));
        const aPos = aIndex === -1 ? 9999 : aIndex;
        const bPos = bIndex === -1 ? 9999 : bIndex;
        return aPos - bPos;
      });
      setUpdatedMenuData([...finalMenu.slice(0, 2), {
        menuid: 2,
        menu: 'Leads',
        moduleid: leadFinderModule.moduleid,
        modulename: leadFinderModule.modulename
      }, ...finalMenu.slice(2)]);
    }

  }, [menuOpen]);

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={menuOpen}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Add More Menu
        </DialogTitle>
        <DialogContent>
          {dataLoading && (<LoadingPage />)}
          <List style={{ padding: 0 }}>
            {updatedMenuData?.length > 0 &&
              updatedMenuData.map((a, idx) => {
                const hasModules = a?.modules?.length > 0;
                const isOpen = openItems[a.name];
                const isPinned = a?.moduleid ?
                  [...pinnedItems].find((i) => (a.moduleid === i.moduleid) && (a.menuid === i.menuid))
                  : [...pinnedItems].filter((i) => a.menuid === i.menuid).length >= a.modules?.length;

                return (
                  <div key={idx}>
                    <ListItem
                      button
                      onClick={() =>
                        hasModules && toggleOpen(a.name)
                      }
                      style={{ padding: 0 }}>
                      <ListItemText
                        primary={
                          <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                            {a.modulename || a.name}
                          </Typography>
                        }
                      />
                      {hasModules &&
                        (isOpen ? <ExpandLess /> : <ExpandMore />)}
                      <Checkbox
                        size="small"
                        color="primary"
                        checked={isPinned}
                        onClick={(e) => {
                          e.stopPropagation();
                          togglePin(a);
                        }}
                      />
                    </ListItem>
                    {/* Submodules */}
                    {hasModules && (
                      <Collapse in={isOpen} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                          {a.modules.map((mod, subIdx) => {
                            mod.menuid = a.menuid;
                            const isModPinned = [...pinnedItems].find((a) => a.moduleid === mod.moduleid);
                            return (
                              <ListItem
                                key={subIdx}
                                style={{ paddingLeft: 32 }}
                                dense
                              >
                                <ListItemText
                                  primary={
                                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                                      {mod.name}
                                    </Typography>
                                  }
                                />
                                <Checkbox
                                  size="small"
                                  color="primary"
                                  checked={isModPinned}
                                  onChange={() => {
                                    togglePin(mod)
                                  }}
                                />
                              </ListItem>
                            );
                          })}
                        </List>
                      </Collapse>
                    )}
                  </div>
                );
              })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            size='small'
            color='secondary'
            variant='contained'
            onClick={() => {
              setMenuOpen(false)
              setOpenItems([]);
            }}
          >
            Cancel
          </Button>
          <Button
            size='small'
            color='primary'
            variant='contained'
            onClick={async () => {
              setDataLoading(true);
              await postDataRequest(config.baseURLApi, {
                query: UpdateUserPinMenu,
                variables: {
                  pinmenus: pinnedItems,
                  userid: JSON.parse(localStorage.getItem('userid'))
                },
              }).then((res) => {
                if (res?.data?.updateUserPinMenu) {
                  showNotification('Menu pinned successfully', 'success');
                  setMenuOpen(false);
                  setOpenItems([]);
                  window.location.reload();
                }
              });
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Drawer
        variant={isPermanent ? 'permanent' : 'temporary'}
        className={classNames(classes.drawer, {
          [classes.drawerOpen]: !isPermanent
            ? !isSidebarOpened
            : isSidebarOpened,
          [classes.drawerClose]: !isPermanent
            ? isSidebarOpened
            : !isSidebarOpened,
        })}
        classes={{
          paper: classNames({
            [classes.drawerOpenPaper]: !isPermanent
              ? !isSidebarOpened
              : isSidebarOpened,
            [classes.drawerClose]: !isPermanent
              ? isSidebarOpened
              : !isSidebarOpened,
          }),
        }}
        open={!isPermanent ? !isSidebarOpened : isSidebarOpened}
        onClose={toggleDrawer(true)}
        onMouseEnter={() => (!isSidebarOpened ? (toggleSidebar(layoutDispatch), setOpenOnHover(true)) : '')}
        onMouseLeave={() => ((isSidebarOpened && openOnHover) ? (toggleSidebar(layoutDispatch), setOpenOnHover(false)) : '')}
      >
        <div className={classes.toolbar} />
        <div className={classes.mobileBackButton}>
          <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          </IconButton>
        </div>
        <List
          className={classes.sidebarList}
          classes={{ padding: classes.padding }}
        >
          {filteredStructure.map((link) => {
            return (!(link?.label === 'Professional Services' && whiteLabelData?.isdisabledexpertservices === true)) ? (
              <SidebarLink
                setOpenSideBar={setOpenSideBar}
                home={home}
                userPermissions={userPermissions}
                settings={settings}
                professionalServices={professionalServices}
                reputationCentral={reputationCentral}
                prospectCentral={prospectCentral}
                marketingCentral={marketingCentral}
                promotionCentral={promotionCentral}
                productService={productService}
                insightsCentral={insightsCentral}
                leadCentral={leadCentral}
                salesCentral={salesCentral}
                openSideBar={openSideBar}
                propertyManagement={propertyManagement}
                linkedIn={linkedIn}
                whastApp={whastApp}
                getToogleBodyStatus={getToogleBodyStatus}
                key={link.id}
                location={location}
                isSidebarOpened={!isPermanent ? !isSidebarOpened : isSidebarOpened}
                {...link}
                toggleDrawer={toggleDrawer(true)}
              />
            ) : null;
          })}
          <ListItem
            style={{ padding: '5px 16px', background: '#005EB2' }}
            onClick={() => {
              setMenuOpen(true);
              toggleDrawer(true);
            }}
          >
            <Add style={{ color: 'white' }} />
            <Link
              style={{ color: '#D6D6D6', textDecoration: 'none', paddingLeft: '22px', fontSize: '11px' }}
              target='_blank'
            >
              Add More
            </Link>
          </ListItem>
          {/* <>
            <Divider style={{ marginTop: 20 }} />
            {((whiteLabelData?.isdisabledgetdemo === false) && hasPermission()) ? <div className={classes.sidebarBottom}>
              <center>
                <Link href={handleUndefined(whiteLabelData?.appointmenturl) || "https://app.bixjet.com/appointment/sd/meeting-with-sd@bixpand.com"} target="_blank">
                  <Box display="flex" flexWrap="wrap" flexDirection="row" alignItems="center">
                    {logo ? (
                      <img
                        src={logo}
                        className={classes.bixpandLogo}
                        alt="bixpand"
                      />
                    ) : ''}
                    {sideBarLogo ? (
                      <img
                        src={sideBarLogo}
                        className={classNames({
                          [classes.sidebarLogo]: !isPermanent
                            ? !isSidebarOpened
                            : isSidebarOpened,
                          [classes.sidebarLogoUnvisible]: !isPermanent
                            ? isSidebarOpened
                            : !isSidebarOpened,
                        })}
                        alt="bixpand"
                      />
                    ) : ''}
                  </Box>
                </Link>
              </center>
            </div> : ''}
          </> */}
        </List>
      </Drawer>
    </>
  );
}
export default withRouter(Sidebar);
